export const isReelCard = cardType => {
	return cardType?.toLowerCase () === "reel";
};